import type { Exercise } from '../../types/content';
import { strings, text } from './contentFields';

export interface OpenResponseModel {
  kicker: string;
  title: string;
  intro: string;
  promptLabel: string;
  prompt: string;
  suggestions: string[];
  models: string[];
  allowMicrophone: boolean;
}

export function openResponseModel(exercise: Exercise): OpenResponseModel {
  const content = exercise.content;
  if (exercise.type === 'construction') return {
    kicker: 'BYGG EN NATURLIG REPLIKK', title: 'Bind tankene sammen.', intro: text(content, 'instruction'),
    promptLabel: 'TANKER', prompt: strings(content, 'facts').join(' · '), suggestions: strings(content, 'requiredLanguage'),
    models: strings(content, 'models'), allowMicrophone: false
  };
  if (exercise.type === 'reformulation') return {
    kicker: 'FRA RIKTIG TIL NATURLIG', title: 'Behold meningen. Endre språket.', intro: text(content, 'instruction'),
    promptLabel: 'SKRIV OM', prompt: text(content, 'original'), suggestions: strings(content, 'suggestedLanguage'),
    models: strings(content, 'models'), allowMicrophone: false
  };
  if (exercise.type === 'extended-production') return {
    kicker: 'SNAKK UTEN MANUS', title: text(content, 'communicativeGoal', 'Løs situasjonen med egne ord.'), intro: text(content, 'role'),
    promptLabel: 'SITUASJON', prompt: text(content, 'situation'), suggestions: strings(content, 'optionalLanguage'),
    models: strings(content, 'models'), allowMicrophone: true
  };
  if (exercise.type === 'error-repair') return {
    kicker: 'REPARER MØNSTERET', title: 'Finn en bedre formulering.', intro: text(content, 'explanation'),
    promptLabel: 'SETNING', prompt: text(content, 'fallbackOriginal'), suggestions: [],
    models: [text(content, 'correctedModel'), text(content, 'transferModel')].filter(Boolean), allowMicrophone: false
  };
  return {
    kicker: 'SAMTALETRENING', title: text(content, 'learnerGoal', 'Svar på replikken.'),
    intro: `${text(content, 'learnerRole')} ${text(content, 'interlocutorRole')}`.trim(),
    promptLabel: 'FØRSTE REPLIKK', prompt: text(content, 'openingTurn'), suggestions: [], models: [], allowMicrophone: true
  };
}
